<button
  type="button"
  class="bricks-button button-fn button-icon-only"
  [class.show-scroll-top]="showScrollTopButton"
  (click)="scrollToTop()"
  matTooltip="Zum Anfang"
  matTooltipPosition="left"
  matTooltipClass="custom-tooltip-left"
  matTooltipShowDelay="600"
  mat-fab>
  <bricks-icon name="arrow-up" size="16">bricks-arrow-up</bricks-icon>
</button>
